import { all, takeEvery, put, take } from 'redux-saga/effects'
import { closeFeatures } from 'actions/mainView'
import * as ActionTypes from '~/actions/ActionTypes'

function* handleCloseView() {
  yield put(closeFeatures())
}

function* applyRefFile({ payload }) {
  if (payload.visibility) {
    const action = yield take([ ActionTypes.SHOW_REFERENCE_FILE_CHOICE_WINDOW ])
    if (action.payload.apply) {
      yield put(payload.getAction())
    }
  }
}

function* watchAll() {
  yield all([
    takeEvery([
      ActionTypes.OPEN_CHAPTER,
      ActionTypes.ASSET_EDIT_STARTED,
    ], handleCloseView),
    takeEvery([ ActionTypes.SHOW_REFERENCE_FILE_CHOICE_WINDOW ], applyRefFile),
  ])
}

export default watchAll
